import React from "react";
import {useNavigate, useParams} from "react-router-dom";
import {DEFAULT_SECTION} from "./sectionPaths";

// Shown for a URL under /project/:id that names no section - a mistyped
// address, or a link to a section that has since been renamed. Previously the
// route switch returned null for these, so the project's whole chrome rendered
// around an empty content area with nothing to say what had happened.
export default props => {
    const {id} = useParams();
    const navigate = useNavigate();

    return (
        <div className={"section-placeholder"}>
            <h2>Section not found</h2>
            <p>This part of the project doesn't exist.</p>
            <a
                href={`/project/${id}/${DEFAULT_SECTION}`}
                onClick={(e) => {e.preventDefault(); navigate(`/project/${id}/${DEFAULT_SECTION}`)}}
            >
                Back to the project
            </a>
        </div>
    )
}
